<script setup lang="ts">
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import TaskOrDocOrSkillPreviewTooltip from "~/components/dumb/TaskOrDocOrSkillPreviewTooltip.vue";
import { TypeaheadSpecialEntity } from "~/shared/enums";
import type { TypeaheadOption } from "~/shared/types";

defineProps<{
  item: TypeaheadOption;
  isMultiSelect?: boolean;
}>();

const emit = defineEmits<{
  select: [TypeaheadOption];
}>();
</script>

<template>
  <TaskOrDocOrSkillPreviewTooltip
    :task-duid="item.specialEntity === TypeaheadSpecialEntity.TASK ? item.value.toString() : undefined"
    :doc-duid="item.specialEntity === TypeaheadSpecialEntity.DOC ? item.value.toString() : undefined"
    :skill-duid="item.specialEntity === TypeaheadSpecialEntity.SKILL ? item.value.toString() : undefined"
    block
    :distance="isMultiSelect ? 16 : 4"
    @click="emit('select', item)">
    <div class="contents">
      <DropdownMenuItemContent
        :title="item.label"
        :icon="item.icon"
        :icon-args="item.iconArgs"
        :strikethrough="item.strikethrough"
        :is-multi-select="isMultiSelect" />
    </div>
  </TaskOrDocOrSkillPreviewTooltip>
</template>
